
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1qq5l_1yprl_25",
  "inner": "awsui_inner_1qq5l_1yprl_28",
  "skeleton-wave": "awsui_skeleton-wave_1qq5l_1yprl_1",
  "skeleton-wave-rtl": "awsui_skeleton-wave-rtl_1qq5l_1yprl_1",
  "display-block": "awsui_display-block_1qq5l_1yprl_86",
  "display-inline-block": "awsui_display-inline-block_1qq5l_1yprl_90",
  "display-inline": "awsui_display-inline_1qq5l_1yprl_90",
  "variant-text-body-s": "awsui_variant-text-body-s_1qq5l_1yprl_99",
  "variant-text-body-m": "awsui_variant-text-body-m_1qq5l_1yprl_104",
  "variant-text-heading-xs": "awsui_variant-text-heading-xs_1qq5l_1yprl_109",
  "variant-text-heading-s": "awsui_variant-text-heading-s_1qq5l_1yprl_114",
  "variant-text-heading-m": "awsui_variant-text-heading-m_1qq5l_1yprl_119",
  "variant-text-heading-l": "awsui_variant-text-heading-l_1qq5l_1yprl_124",
  "variant-text-heading-xl": "awsui_variant-text-heading-xl_1qq5l_1yprl_129",
  "variant-text-display-l": "awsui_variant-text-display-l_1qq5l_1yprl_134"
};
  